'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from './UiComponent.js';

const privateMap = util.createPrivateMapper();

// function heigthEqual(columns, start, size) {
//   const l = start + size;
//   const base = columns[start].height;
//   let i = start + 1;
//   while (i < l) {
//     if (base != columns[i].height) {
//       return false;
//     }
//     i++;
//   }
//   return true;
// }
// function verticalLayoutItem(width, rowCrop, columns, item) {
//   let l;
//   const sz = item.size;
//   const d = 1; //Math.max(1, (sz. x / width) | 0);
//   const layoutSize = new Point2D();
//   layoutSize.x = width * d;
//   layoutSize.y = layoutSize.x * sz.y / sz.x;
//   // layoutSize.y = ((layoutSize.y / rowCrop) | 0) * rowCrop;
//   domUtil.setSize(item.wrapper, layoutSize);
//   // domUtil.setStyle(item.domEl, 'transform', 'scale(' + (layoutSize.x / sz.x).toFixed(10) + ')');
//   domUtil.setSize(item.domEl, layoutSize);
//   let targetHeight = Infinity;
//   let targetColumn = 0;
//   l = columns.length;
//   console.log(d);
//   let fn = d > 1 ? heigthEqual : function(){return true};
//   for (let i = 0; i <= l - d; i++) {
//     const column = columns[i];
//     if (!fn(columns, i, d)) {
//       continue;
//     }
//     if (column.height == 0) {
//       targetColumn = i;
//       targetHeight = 0;
//       break;
//     }

//     if (targetHeight > column.height) {
//       targetHeight = column.height;
//       targetColumn = i;
//     }
//   }
//   domUtil.setStyle(item.wrapper, 'top', targetHeight.toFixed(0) + 'px');
//   columns[targetColumn].domEl.appendChild(item.wrapper);

//   for (let i = targetColumn; i < targetColumn + d; i++) {
//     columns[i].height += layoutSize.y;
//   }
//   // console.log(targetColumn.height);
// }

// class VerticalLayout {
//   constructor(domEl){
//     const pv = privateMap(this);
//     pv.domEl = domEl;
//     pv.columnBase = 200;
//     pv.columnCount = 1;
//     pv.columnWidth = 1;
//     pv.rowCrop = 20;
//     pv.width = 0;
//     pv.columns = [];

//     domUtil.setStyle(domEl, 'display', 'flex');
//   }
//   constructItem(item){
//     const pv = privateMap(this);
//     // const itemWrapper = domUtil.createElement('div');
//     domUtil.setStyle(item.wrapper, 'boxSizing', 'border-box');
//     // domUtil.setStyle(item.wrapper, 'overflow', 'hidden');
//     domUtil.setStyle(item.wrapper, 'position', 'absolute');
//     domUtil.setStyle(item.wrapper, 'left', '0');
//     // domUtil.setStyle(item.wrapper, 'border', '1px solid #00f');
//     domUtil.setStyle(item.domEl, 'transform-origin', 'top left');
//   }
//   set size(size){
//     const pv = privateMap(this);
//     pv.columns = [];
//     // domUtil.setStyle(this.domEl, 'overflow', 'scroll');
//     pv.width = size.x;
//     // domUtil.setStyle(this.domEl, 'overflow', '');
//     pv.columnCount = (pv.width / pv.columnBase) | 0;
//     pv.columnWidth = (pv.width / pv.columnCount) | 0;

//     pv.columns.length = 0;
//     for (let i = 0; i < pv.columnCount; i++) {
//       const column = domUtil.createElement('div');
//       // domUtil.setStyle(column, 'display', 'inline-block');
//       // domUtil.setStyle(column, 'float', 'left');
//       domUtil.setStyle(column, 'position', 'relative');
//       domUtil.setStyle(column, 'width', pv.columnWidth.toFixed(10) + 'px');
//       pv.domEl.appendChild(column);
//       pv.columns[i] = {
//         height: 0,
//         domEl: column
//       };
//     }
//   }
//   layoutItems(items){
//     const pv = privateMap(this);
//     const l = items.length;
//     for (let i = 0; i < l; i++) {
//       verticalLayoutItem(pv.columnWidth, pv.rowCrop, pv.columns, items[i]);
//     }
//   }
// }

function horizontalLayoutRow(row){
  const heightPx = row.height.toFixed(10) + 'px';
  const l = row.items.length;
  const items = row.items;
  let offset = 0;
  for (let i = 0; i < l; i++) {
    const item = items[i];
    const w = row.height * item.ratio;
    // domUtil.setHeight(item.wrapper, 'height', heightPx);
    domUtil.setLeft(item.wrapper, offset);
    domUtil.setWidth(item.wrapper, Math.ceil(w));
    // domUtil.setStyle(item.domEl, 'transform', 'scale(' + (row.height / item.size.y).toFixed(10) + ')');
    domUtil.setSize(item.domEl, domUtil.getSize(item.wrapper));
    offset += w;
  }
}

class HorizontalLayout {
  constructor(domEl){
    const pv = privateMap(this);
    pv.domEl = domEl;
    pv.thresholdHeight = 400;
  }
  constructItem(item){
    const pv = privateMap(this);
    domUtil.setStyle(item.wrapper, 'display', 'block');
    domUtil.setStyle(item.wrapper, 'position', 'absolute');
    domUtil.setStyle(item.wrapper, 'top', '0');
    domUtil.setStyle(item.wrapper, 'bottom', '0');
    domUtil.setStyle(item.domEl, 'transform-origin', 'top left');
  }
  set size(size){
    const pv = privateMap(this);
    pv.width = size.x;
  }
  layoutItems(items){
    const pv = privateMap(this);
    const l = items.length;
    const width = pv.width;
    const rowBaseEl = domUtil.createElement('div');
    domUtil.setStyle(rowBaseEl, 'position', 'relative');
    domUtil.setStyle(rowBaseEl, 'overflow', 'hidden');
    domUtil.setWidth(rowBaseEl, width);
    let rowEl = rowBaseEl.cloneNode(true);
    let row = {
      minHeight: Infinity,
      denominator: 0,
      items: []
    }
    for (let i = 0; i < l; i++) {
      const item = items[i];
      rowEl.appendChild(item.wrapper);
      // horizontalLayoutItem(pv.width, row, item);
      row.items.push(item);
      row.denominator += item.ratio;
      row.height = width / row.denominator;
      row.minHeight = Math.min(row.minHeight, item.size.y);
      if (row.height < Math.min(row.minHeight, pv.thresholdHeight)) {
        pv.domEl.appendChild(rowEl);
        domUtil.setHeight(rowEl, Math.ceil(row.height));
        horizontalLayoutRow(row);
        rowEl = rowBaseEl.cloneNode(true);
        row = {
          minHeight: Infinity,
          denominator: 0,
          items: []
        }
      }
    }
    if (row.items.length > 0) {
      row.height = Math.min(row.minHeight, pv.thresholdHeight);
      pv.domEl.appendChild(rowEl);
      domUtil.setHeight(rowEl, Math.ceil(row.height));
      horizontalLayoutRow(row);
    }
  }
}

export class MosaicLayout extends UiComponent {
  constructor(domEl){
    super(domEl);
    const pv = privateMap(this);
    pv.items = [];

    this.algorithm = 'H';
  }
  get algorithm(){
    return privateMap(this).algorithmType;
  }
  set algorithm(algorithmType){
    const pv = privateMap(this);
    pv.algorithmType = algorithmType;
    pv.wrapperEl = domUtil.createElement('div');
    domUtil.empty(this.domEl);
    this.domEl.appendChild(pv.wrapperEl);
    // if (algorithmType == 'V') {
    //   pv.algorithm = new VerticalLayout(pv.wrapperEl);
    // } else {
    //   pv.algorithm = new HorizontalLayout(pv.wrapperEl);
    // }
    pv.algorithm = new HorizontalLayout(pv.wrapperEl);
    this.applySize();
  }
  addItem(itemDef){
    const pv = privateMap(this);
    const itemWrapper = domUtil.createElement('div');
    // document.body.appendChild(itemDef.domEl);
    const item = {
      domEl: itemDef.domEl,
      size: itemDef.size,
      wrapper: itemWrapper
    };
    item.ratio = item.size.x / item.size.y;
    itemWrapper.appendChild(item.domEl);
    pv.algorithm.constructItem(item);
    pv.items[pv.items.length] = item;
  }
  addItems(itemDoms){
    const l = itemDoms.length;
    for (let i = 0; i < l; i++) {
      this.addItem(itemDoms[i]);
    }
    this.layout();
  }
  layout(){
    const pv = privateMap(this);
    pv.algorithm.layoutItems(pv.items);
  }
  applySize(){
    const pv = privateMap(this);
    // domUtil.setStyle(this.domEl, 'overflow', 'scroll');
    pv.size = domUtil.getSize(this.domEl);
    console.log(pv.size);
    // domUtil.setStyle(this.domEl, 'overflow', '');
    domUtil.empty(pv.wrapperEl);
    // while (pv.wrapperEl.firstChild) {
    //   pv.wrapperEl.removeChild(pv.wrapperEl.firstChild);
    // }
    pv.algorithm.size = pv.size;

    this.layout();
  }
}